import { useSyncExternalStore } from "react";

import { buildVersionedUrl } from "./appVersion";
import { navigateTo } from "./navigateTo";

/**
 * Tiny shared store: "a newer build is deployed, and this one is stale".
 * Written by VersionWatcher; read by the header Update pill and the account
 * menu item so the prompt stays reachable after the toast is dismissed.
 */
let latestVersion: string | null = null;
const listeners = new Set<() => void>();

export function setUpdateAvailable(latest: string | null): void {
  if (latest === latestVersion) return;
  latestVersion = latest;
  listeners.forEach((l) => l());
}

export function getUpdateAvailable(): string | null {
  return latestVersion;
}

/** The pending target version, or null when this client is up to date. */
export function useUpdateAvailable(): string | null {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => void listeners.delete(cb);
    },
    getUpdateAvailable,
    getUpdateAvailable,
  );
}

/**
 * User-initiated refresh: navigate this window to the current URL with
 * `?_v=<latest>` so the document can't come from a stale HTTP-cache entry
 * (main.tsx strips the param after boot).
 */
export function refreshToLatest(latest: string): void {
  navigateTo(buildVersionedUrl(window.location.href, latest));
}
